
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import img1  from "../../assets/img/about_img.jpg"
import img1 from "../../assets/img/6.webp"
// import img2  from "../../assets/img/17.jpg"
import img2 from "../../assets/img/9.webp"
import img3 from "../../assets/img/10.webp"



const about_slider = [
  {
    img: img1,
    sub_title: "Our Vision",
    title: `Transforming Ideas into Digital Success`,
    des: `As India's leading Digital Marketing & IT Solutions Company, DOAGuru InfoSystems delivers measurable results. From SEO & Google Ads to custom software development and web solutions we help businesses across India grow online with confidence.`,
  },
  {
    img: img2,
    sub_title: "Our Mission",
    title: `Unleashing Creativity to Transform Your Business`,
    des: `Our mission is to empower businesses to thrive in the digital realm by furnishing them with tailor-made solutions that cater to their unique needs. We recognize that each business possesses its distinctive traits.`,
  },
  {
    img: img3,
    sub_title: "Our Core Value",
    title: `Driven by Creativity, Focused on Results`,
    des: `At the heart of our operations is a commitment to prioritising the requirements of our customers and building robust connections grounded in mutual satisfaction and trust. Our dedication to social responsibility underscores our values.`,
  },
]

const AboutHomeOne = () => {
  return (
    <>
      <div className="cs_height_130 cs_height_lg_60"></div>
      <Swiper
        loop={true}
        speed={1000}
        modules={[Navigation, Pagination]}
        navigation={{
          nextEl: ".cs_swiper_button_next",
          prevEl: ".cs_swiper_button_prev",
        }}
        pagination={{
          el: ".cs_pagination",
          clickable: true,
          type: "fraction",

          renderFraction: function (currentClass, totalClass) {
            return `<span class="${currentClass}"></span> 
             ${' / '}
             <span class="${totalClass}"></span>`;
          },

        }}
        className="cs_slider cs_slider_2">
        {about_slider.map((item, index) => (
          <SwiperSlide key={index} className="swiper-slide">
            <div className="cs_about cs_style_1">
              <div className="cs_about_bg cs_bg" style={{ backgroundImage: `url(${item.img})` }}></div>
              <div className="container">
                <div className="cs_about_text">
                  <div className="cs_section_heading cs_style_1">
                    <div className="cs_section_heading_text">
                      <div className="cs_section_subtitle">{item.sub_title}</div>
                      <h2 className="cs_section_title">
                        {item.title}
                      </h2>
                    </div>
                  </div>
                  <div className="cs_height_40 cs_height_lg_30"></div>
                  <p className="cs_m0">
                    {item.des}
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}

        <div className="container">
          <div className="cs_swiper_controll">
            <div className="cs_pagination cs_style2 cs_primary_font"></div>
            <div className="cs_swiper_navigation_wrap">

              <div style={{ cursor: 'pointer' }} className="cs_swiper_button_prev">
                <svg width="82" height="24" viewBox="0 0 82 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M82 1H2L24 23" stroke="currentColor" />
                </svg>
              </div>
              <div style={{ cursor: 'pointer' }} className="cs_swiper_button_next">
                <svg width="82" height="24" viewBox="0 0 82 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 23H80L58 1" stroke="currentColor" />
                </svg>
              </div>

            </div>
          </div>
        </div>
      </Swiper>
    </>
  );
};

export default AboutHomeOne;